import { graphql } from '@/gql';
import type { UpdateCallLogMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateCallLog = async ({ id, data }: UpdateCallLogMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation UpdateCallLog($data: CallLogInputType!, $id: Float!) {
        updateCallLog(data: $data, id: $id) {
          id
          callerId
          rideId
          scheduledRideId
          operatorId
          fromPhoneNumber
          toPhoneNumber
          callFlow
          purpose
          timeStart
          timeEnd
          waitStart
          waitEnd
          callSid
          notes
          reason
          callerName
          operatorName
          timeZone
          qualityAssurance
          hasRecording
          lovedOneId
          lovedOneName
          callActions {
            callLogId
            userId
            userName
            userType
            action
            createdAt
          }
        }
      }
    `),
  });

  return response.data?.updateCallLog;
};
